import { render, staticRenderFns } from "./VendorBasicDetails.vue?vue&type=template&id=73e9b03e&"
import script from "./VendorBasicDetails.vue?vue&type=script&lang=js&"
export * from "./VendorBasicDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports